import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule, DatePipe } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import {
  MatSidenav,
  MatSidenavContainer,
  MatSidenavContent,
  MatSidenavModule,
} from '@angular/material/sidenav';
import { DrawerService } from '../../services/shared/Drawer.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormArray, FormGroup, FormBuilder, FormsModule, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MyfavouriteComponent } from '../myfavourite/myfavourite.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DashboardService } from '../../services/shared/dashboard.service';
import { PromtUserService } from '../../services/prompt-user.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { FavComponentDailogComponent } from '../../dailog/fav-component-dailog/fav-component-dailog.component';
import { GamificationCardsComponent } from '../../gamification-cards/gamification-cards.component';
import { MultiSelectDropdownComponent } from '../common/components/multi-select-dropdown/multi-select-dropdown.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { RatingFeedbackComponent } from '../../rating-feedback/rating-feedback.component';
import { SaveSuccessComponent } from '../../save-success/save-success.component';
import { SelectDropdownComponent } from '../common/components/select-dropdown/select-dropdown.component';
import { ButtonComponent } from '../common/components/button/button.component';
import { LoaderComponent } from '../common/components/loader/loader.component';
import { PromptCreateService } from '../../services/prompt-create.service';
import { SnackBarComponent } from '../common/components/snack-bar/snack-bar.component';
import { timeZoneDate } from '../../utils/date.utils';
import timezone from 'moment-timezone';
import moment from 'moment';
import { DateTimeFormatterPipe } from '../common/pipes/date-time-formatter.pipe';
import { RemoveFavoriteComponent } from '../../remove-favorite/remove-favorite.component';
import { SearchService } from '../../services/shared/search.service';
import { debounceTime } from 'rxjs';
import { ErrorNotficationComponent } from '../../error-notfication/error-notfication.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-promt-user',
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
    CdkAccordionModule,
    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,
    MatSidenavModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatDialogModule,
    MyfavouriteComponent,
    MatStepperModule,
    GamificationCardsComponent,
    MultiSelectDropdownComponent,
    SelectDropdownComponent,
    ReactiveFormsModule,
    ButtonComponent,
    LoaderComponent,
    DateTimeFormatterPipe
  ],
  providers: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './promt-user.component.html',
  styleUrl: './promt-user.component.scss',
})
export class PromtUserComponent {
  style1: boolean = false;
  clearfilter: boolean = false
  style2: boolean = false;
  isBordered: boolean = false;
  isDrawerOpen = false;
  categories: any = [];
  createdBy: any = [];
  promptCreatedBy: any = '';
  promptCategory: any = '';
  promptDetails: any = [];
  selectedValue: any;

  allCatSelectOption: boolean = false;
  allCatSelectOptionValue: any;
  myFavSelectOption: boolean = false;
  myFavSelectOptionValue: any;
  myPromptsSelectOption: boolean = false;
  myPromptsSelectOptionValue: any;
  apprPendingSelectOption: boolean = false;
  apprPendingSelectOptionValue: any;

  sortOption = ['Most Used', 'All', 'Favorite'];
  selectedCardIndex: number | null = null;
  Status = [{ name: 'Draft', value: 'DRAFT' },
  { name: 'Submitted', value: 'SUBMITTED' },
  { name: 'Published', value: 'PUBLISHED' },
  { name: 'Unpublished', value: 'UNPUBLISHED' },
  { name: 'Rejected', value: 'REJECTED' },
  { name: 'Revoked', value: 'REVOKED' }];
  sortOptions = [{ name: 'Most Used', value: 'most used' }, { name: 'Least Used', value: 'least used' }, { name: 'Highest Rated', value: 'highest rated' }, { name: 'Lowest Rated', value: 'lowest rated' }, { name: 'Old to New', value: 'old to new' }, { name: 'New to Old', value: 'new to old' }];
  defaultSortOptions = [{ name: 'Most Used', value: 'most used' }, { name: 'Least Used', value: 'least used' }, { name: 'Highest Rated', value: 'highest rated' }, { name: 'Lowest Rated', value: 'lowest rated' }, { name: 'Old to New', value: 'old to new' }, { name: 'New to Old', value: 'new to old' }];
  myPromptsApprPendingSortOptions:any = [{ name: 'Old to New', value: 'old to new' }, { name: 'New to Old', value: 'new to old' }];
  public attachments: any[] = [];
  userid: any;
  fileNames: any[] = [];
  public isLoading: boolean = false;
  selectedLibrary: any = 'All Categories';
  allcategory: any = [];
  dropDownCategories: any = [];
  model: any;
  allPrompt: any;
  creatore: any;
  dropdownCreators: any = [];
  fromSearchData: any;
  promptUserDetails: any;
  gptScore: any;
  modal: any;
  createdbyarray: any;
  onMyFavouriteClick: boolean = false;
  onMyPromptsClick: boolean = false;
  category_id: any = [];
  promptlist: any;
  onMyApprovalClick: boolean = false;
  isfavourite: boolean = false
  user_role: any;
  promptCount: any;
  status: any = [];
  sub_category_id: any = [];
  permanentAttachments: any[] = [];
  noteslist: any = [];
  selectedCat: any = [];
  selectedStatus: any = [];
  selectedCreatedBy: any = [];
  selectedModel: any = [];
  showVersionInstruction=false;
  tooltipStyle: { [key: string]: string } = {};
  version_reason:string='';
  created_from:string='';
  @ViewChild(MyfavouriteComponent) FavComponent!: MyfavouriteComponent;

  categoryDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    enableCheckAll: false,
  };
  statusDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    enableCheckAll: false,
  };
  creatorsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    enableCheckAll: false,
  };
  modelDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    enableCheckAll: false
  }
  searchtext: string = "";
  sub_category: any;
  sort_by: string = "";
  published_on: any;
  parentCate: boolean = false;
  parentCatename: any;
  addfavclicked: boolean = false;
  isPromptRunning: boolean = false;
  @ViewChild('expandable') expandableContent!: ElementRef;
  @ViewChild('otherAttachments') otherAttachmentsContainer!: ElementRef;
  isExpandableContentOverflowed: boolean = false;
  isExpand: boolean = false
  promptId: any;
  breadcrumb: any;
  showNotes: boolean = true;
  notesData: any;
  newAttachmentFiles: any[] = [];
  selectedIndex: any = 0;
  myForm: FormGroup;
  tabs: { label: string, myForm: FormGroup }[] = [];
  moment = moment;
  timeZoneDate = timeZoneDate;
  timezone = timezone;
  public DD_MMM_YYYY_H_MM_A: any = 'DD-MMM-YYYY h:mm a';

  attachmentForm: FormGroup;
  attachmentTabs: { attachmentForm: FormGroup }[] = [];

  constructor(
    private dialog: MatDialog,
    private dashboardService: DashboardService,
    private promptUserService: PromtUserService,
    private drawerService: DrawerService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    private promptCreateService: PromptCreateService,
    private searchService: SearchService,
    private authService:AuthService,
  ) {
    this.myForm = this.fb.group({
      promptDetails: "",
      variables: this.fb.array([]),
      variablesCopy: this.fb.array([]),
      gptQuestion: ""
    });
    this.attachmentForm = this.fb.group({
      otherAttachment: [null],
    });
  }
  async ngOnInit() {

    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;

    if (this.user_role === 'user') {
      // this.selectedValue = "Most Used"
      // this.sortOptions = this.sortOptionsForConsumer
    }
    if (this.user_role === 'creator') {
      // this.selectedValue = "New to Old"
      // this.sortOptions = this.sortOptionsForCreator
    }
    if (this.user_role === 'curator') {
      // this.selectedValue = "Old to New"
      // this.sortOptions = this.sortOptionsForCurator
    }

    if (this.user_role === 'admin') {
      // this.selectedValue = "Old to New"
      // this.sortOptions = this.sortOptionsForCurator
    }

   
    
    let sortValue = this.sortOptions.filter(e => e.name == this.selectedValue)
    // this.sort_by = sortValue[0]?.value
    this.sort_by = 'most used';


    this.drawerService.currentDrawerState.subscribe((state) => {
      this.isDrawerOpen = state;
    });

    this.getAllPromt();
    this.getCategory();
    this.selectedLibrary = 'All Categories';
    this.drawerService.closeDrawer();
    this.selectedCardIndex = null
    this.cd.markForCheck();
    this.clearfilter = true
    setTimeout(() => {
      this.clearfilter = false
    }, 10)

    // this.dashboardService.currentData.subscribe((data : number) => {
    //   this.userid = data;
    //   if (this.userid == 1) {
    //     this.user_role = 'admin';
    //   } else if (this.userid == 2) {
    //     this.user_role = 'curator';
    //   } else if (this.userid == 3) {
    //     this.user_role = 'creator';
    //   } else if (this.userid == 4) {
    //     this.user_role = 'user';
    //   }

    // });

    this.dashboardService.initialData.pipe(debounceTime(1000)).subscribe((data: any) => {
      this.searchtext = data.searchText;
      
      this.category_id = []
      this.sub_category_id = []

      let getSelectedCat = localStorage.getItem("selected_cat")
      
      if(getSelectedCat && (getSelectedCat == 'My Prompts' || 'Approval Pending')) {        
        this.sortOptions = this.myPromptsApprPendingSortOptions;
      } else {
        this.sortOptions = this.defaultSortOptions;
        this.selectedValue = "Most Used";
      }

      // let searchData = this.searchService.getSearchData();
      // console.log("searchData", searchData)
      // if(Object.keys(searchData).length > 0) {
      //   // getSelectedCat = JSON.stringify(searchData)
      //   // this.searchService.setSearchData({})
      //   this.category_id = []
      //   this.sub_category_id = []
      // } else {
      //   getSelectedCat = localStorage.getItem("selected_cat")
      // }

      try {
        if(getSelectedCat != null) {
          let parsedSelectedCat = JSON.parse(getSelectedCat)
          if (parsedSelectedCat.subcategories) {
            if(parsedSelectedCat.id) {
              this.category_id.push(parsedSelectedCat.id);
            }
          }
          else {
            if(parsedSelectedCat.id) {
              this.sub_category_id.push(parsedSelectedCat.id)
            }
          }
        }
      } catch (e) {
          // If parsing fails, keep it as a string
          
      }
      
      // if(getSelectedCat != null) {
      //   let parsedSelectedCat = JSON.parse(getSelectedCat)
      //   if(typeof parsedSelectedCat == 'object') {
      //     if (parsedSelectedCat.subcategories) {
      //       if(parsedSelectedCat.id) {
      //         this.category_id.push(parsedSelectedCat.id);
      //       }
      //     }
      //     else {
      //       if(parsedSelectedCat.id) {
      //         this.sub_category_id.push(parsedSelectedCat.id)
      //       }
      //     }
      //   }
      // }
      
      this.getallprompmtByfilter(
        this.searchtext,
        this.userid,
        [],
        // [],
        // [],
        this.category_id,
        this.sub_category_id,
        [],
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.onMyApprovalClick,
        this.user_role,
        [],
        this.sort_by
      );
      this.getAllCategory(
        this.searchtext,
        this.userid,
        [],
        [],
        [],
        [],
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.user_role,
        []
      );
    });

    this.getModel();
    this.getAllCreatore();
  }

  checkIsExpandableContentOverflowed() {
    this.isExpandableContentOverflowed = this.expandableContent.nativeElement.scrollHeight > this.expandableContent.nativeElement.clientHeight
  }

  onChange(option: any) {
    
    // if(this.selectedLibrary == 'All Categories') {
    //   this.allCatSelectOption = true;
    //   this.allCatSelectOptionValue = option.name;
    // } else if (this.selectedLibrary == 'My Favourites') {
    //   this.myFavSelectOption = true;
    //   this.myFavSelectOptionValue = option.name;
    // } else if (this.selectedLibrary == 'My Prompts') {
    //   this.myPromptsSelectOption = true;
    //   this.myPromptsSelectOptionValue = option.name;
    // } else if (this.selectedLibrary == 'Approval Pending') {
    //   this.apprPendingSelectOption = true;
    //   this.apprPendingSelectOptionValue = option.name;
    // }

    this.sort_by = option.name.toLowerCase();
    this.selectedValue = option.name;
    this.getallprompmtByfilter(
      this.searchtext,
      this.userid,
      this.modal,
      this.category_id,
      this.sub_category_id,
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.onMyApprovalClick,
      this.user_role,
      this.status,
      this.sort_by
    )
  }

  isVariantActive():boolean{ //if logged in user is creator or currator
    if (this.authService.userRole() == 'user' || this.authService.userRole() == ''){
      return false;
    }
    return true;
  }

  isSelectedForA(A: number, B: number): boolean {
    if(A == null) A=0;
    if(B == null) B=0;
    
    
    if (A === 0 && B === 0) return true;        // Only A gets selected when both 0
    if (B > 0 && A === 0) return true;           // B > 0, select opposite (A div)
    if (A > 0 && B > 0) return true;             // Both > 0, select both
    return false;
  }
  
  isSelectedForB(A: number, B: number): boolean {
    if(A == null) A=0;
    if(B == null) B=0;
    
    if (A === 0 && B === 0) return false;        // B should not be selected when both 0
    if (A > 0 && B === 0) return true;            // A > 0, select opposite (B div)
    if (A > 0 && B > 0) return true;             // Both > 0, select both
    return false;
  }


  async downloadFile(file: any, type: any, prompt_id: any, prompt_title: any, prompt_detail_id: any): Promise<void> {

     try {
       const fileName = file; // Default file name
 
      
       const presSignedUrlRequest = {
         prompt_id: prompt_id,
         title: prompt_title,
         url_type: 'get_object',
         prompt_detail_id: prompt_detail_id,
         attachment_type: "permanent_attachments",//"prompt_attachments",
         file_name: fileName,
         user_id:this.userid
       }
 
       const response = await this.promptCreateService.getPresignedUrl(presSignedUrlRequest).toPromise();
 
 
       if (response?.data?.url) {
         const fileUrl = response.data.url;
         
         // Fetch the file as a blob
         const fileResponse = await fetch(fileUrl);
         const blob = await fileResponse.blob();
 
         // Create a temporary anchor element for downloading the file
         const anchor = document.createElement('a');
         const objectUrl = URL.createObjectURL(blob);
         anchor.href = objectUrl;
         anchor.download = fileName;
 
         // Trigger the download
         anchor.click();
 
         // Release the object URL to free memory
         URL.revokeObjectURL(objectUrl);
         } else {
           console.error('Failed to get presigned URL');
         }
         } catch (error: any) {
           console.error('An error occurred while fetching the URL:', error);
       }
  }


  onChangeModal(event: any) {
    this.selectedModel = event.value;
    this.modal = event.value.map((item: any) => item.id);
    this.getallprompmtByfilter(
      this.searchtext,
      this.userid,
      this.modal,
      this.category_id,
      this.sub_category_id,
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.onMyApprovalClick,
      this.user_role,
      this.status,
      this.sort_by
    );
    this.getAllCategory(
      '',
      this.userid,
      this.modal,
      [],
      [],
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.user_role,
      this.status
    );
  }
  onChangeCategory(event: any) {
    this.selectedCat = event.value;
    const selectedValues = event.value.map((item: any) => item.id);
    const subcategoryIds = selectedValues.filter((id: any) => {
      return this.allcategory.some((category: any) =>
        category.subcategories.some((sub: any) => sub.id === id)
      );
    });
    const categoryIds = selectedValues.filter((id: any) => {
      return this.allcategory.some((category: any) => category.id === id);
    });

    this.category_id = categoryIds;
    this.sub_category_id = subcategoryIds;

    this.getallprompmtByfilter(
      this.searchtext,
      this.userid,
      this.modal,
      this.category_id,
      this.sub_category_id,
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.onMyApprovalClick,
      this.user_role,
      this.status,
      this.sort_by
    );
    this.getAllCategory(
      '',
      this.userid,
      this.modal,
      [],
      [],
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.user_role,
      this.status
    );
  }

  onChangeCreatedby(event: any) {
    this.selectedCreatedBy = event.value;
    this.createdbyarray = event.value.map((item: any) => item.id);
    this.getallprompmtByfilter(
      this.searchtext,
      this.userid,
      this.modal,
      this.category_id,
      this.sub_category_id,
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.onMyApprovalClick,
      this.user_role,
      this.status,
      this.sort_by
    );
    this.getAllCategory(
      '',
      this.userid,
      this.modal,
      [],
      [],
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.user_role,
      this.status
    );
  }

  onChangeStatus(event: any) {
    this.selectedStatus = event.value;
    this.status = event.value.map((item: any) => item.value);
    this.getallprompmtByfilter(
      this.searchtext,
      this.userid,
      this.modal,
      this.category_id,
      this.sub_category_id,
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.onMyApprovalClick,
      this.user_role,
      this.status,
      this.sort_by
    );
    this.getAllCategory(
      '',
      this.userid,
      this.modal,
      [],
      [],
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.user_role,
      this.status
    );
  }

  getAllPromt(page_number?: number) {
    if (page_number == undefined || page_number == null) {
      page_number = 1;
    }

    this.promptUserService.getAllPrompts('', this.userid, [], this.category_id ?? [], [], [], this.onMyFavouriteClick, this.onMyPromptsClick, this.onMyApprovalClick, this.user_role, [], this.sort_by, page_number, this.limit).subscribe((response) => {
      if (page_number != 1) {
        let temp_d = [...this.allPrompt, ...response.data.data];
        this.allPrompt = temp_d;
      } else {
        this.allPrompt = response.data.data
      }

     

      // this.allPrompt=this.allPrompt.filter((prompt:any)=> prompt?.prompt_status !='REVOKED');
      this.totalPages = Math.ceil(response.data.total_count / this.limit)
      this.promptlist = response.data
      this.promptCount = response.data.total_count
      this.cd.markForCheck();
    },
      (error) => {

      })

  }
  scrollHeight = 2000;
  @ViewChild('middleCard') middleCard!: ElementRef;

  @HostListener('scroll', ['$event'])
  scrollHandler(event: any) {

    const scrollableElement = this.middleCard.nativeElement;
    const scrollPosition = scrollableElement.scrollTop + scrollableElement.clientHeight;
    //  const scrollHeight = scrollableElement.scrollHeight;

    
    if (scrollPosition > this.scrollHeight) {
      this.scrollHeight = this.scrollHeight + this.scrollHeight;
      // When the user reaches the bottom, load more items
      if (this.totalPages > this.page_number) {
        this.page_number = this.page_number + 1;
        this.getAllPromt(this.page_number)
        this.cd.markForCheck();
      } else {
        this.scrollHeight = 0;
      }
      //  this.loadMoreItems();
    }
  }

  limit = 50;
  totalPages = 0;
  page_number = 1;
  getallprompmtByfilter(search_text: string, userid: number, modal: [], category_id: [], sub_category_id: [], createdbyarray: [], onMyFavouriteClick: boolean, onMyPromptsClick: boolean, onMyApprovalClick: boolean, user_role: string, status: [], sort_by: string) {
    this.isLoading = true
    this.selectedCardIndex = null
    this.drawerService.closeDrawer();
    this.page_number = 1;
    this.scrollHeight = 0;


    //  const scrollHeight = scrollableElement.scrollHeight;

    this.promptUserService.getAllPrompts(search_text, userid, modal, category_id, sub_category_id, createdbyarray, onMyFavouriteClick, onMyPromptsClick, onMyApprovalClick, user_role, status, sort_by, this.page_number, this.limit).subscribe((response) => {

      this.allPrompt = response.data.data
      // this.allPrompt=this.allPrompt.filter((prompt:any)=> prompt?.prompt_status !='REVOKED');

      this.totalPages = Math.ceil(response.data.total_count / this.limit)

      this.promptCount = response.data.total_count
      //this.promptlist = response.data
      this.cd.markForCheck();
      this.isLoading = false
    },
      (error) => {
        console.log(error);
        this.isLoading = false
      })
  }

  getAllCategory(
    search_text: string,
    userid: number,
    modal: [],
    category_id: [],
    sub_category_id: [],
    createdbyarray: [],
    onMyFavouriteClick: boolean,
    onMyPromptsClick: boolean,
    user_role: string,
    status: []
  ) {
    this.promptUserService
      .getAllCate(
        search_text,
        userid,
        modal,
        category_id,
        sub_category_id,
        createdbyarray,
        onMyFavouriteClick,
        onMyPromptsClick,
        user_role,
        status
      )
      .subscribe(
        (response) => {
          this.allcategory = response.data;

          this.cd.markForCheck();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getCategory() {
    this.promptUserService
      .getAllCate(
        this.searchtext,
        this.userid,
        this.modal,
        [],
        [],
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.user_role,
        []
      )
      .subscribe(
        (response) => {
          this.allcategory = response.data;
          let tempCategory: any = [];
          response.data.forEach((element: any, index: any) => {
            if (element.subcategories.length > 0) {
              tempCategory.push(element);
              element.subcategories = element.subcategories.map((item: any) => {
                return { ...item, isNested: true, subcategories: [] };
              });
              tempCategory.push(...element.subcategories);
            } else {
              tempCategory.push(element);
            }
          });
          // this.allcategory = [];
          this.dropDownCategories = JSON.parse(JSON.stringify(tempCategory));
          tempCategory = [];
          this.cd.markForCheck();
        },
        (error) => {
          console.log(error);
        }
      );

  }

  getModel() {
    this.dashboardService.getModel().subscribe(
      (response) => {
        this.model = response.data;
        this.cd.markForCheck();
      },
      (error) => {
        console.log(error);
      }
    );

  }

  getAllCreatore() {
    this.dashboardService.getAllCreatore().subscribe(
      (response) => {
        this.creatore = response.data;
        let tempCreators: any = [];
        this.creatore.forEach((item: any) => {
          tempCreators.push({
            name: item.firstname + ' ' + item.lastname,
            id: item.id,
          });
        });
        this.dropdownCreators = JSON.parse(JSON.stringify(tempCreators));
        this.cd.markForCheck();
      },
      (error) => {
        console.log(error);
      }
    );

  }

  chnge() {
    this.style2 = !this.style1;
  }

  toggleDrawer() {
    this.drawerService.closeDrawer();
    this.selectedCardIndex = null
  }
  convertToList(data: any) {
    if (data) {
      const bulletLines = data.split('\n').filter((line: any) => line.trim() !== '');
      return bulletLines;
    }
  }
  consumePrompt(prompt: any, index?: number) {
    this.showNotes = true;
    this.promptUserService.setStepperIndex(0);
    this.attachmentTabs.forEach((attachment: any) => {
      attachment.attachmentForm.patchValue({
        otherAttachment: []
      });
    })
    if (this.user_role === 'user' || this.user_role === 'creator' && (this.addfavclicked) || (this.user_role === 'creator' && (prompt.prompt_status === "PUBLISHED" || prompt.prompt_status === "SUBMITTED")) || ((this.user_role === 'curator' && prompt.prompt_status === "PUBLISHED") || (this.user_role === 'admin' && prompt.prompt_status === "PUBLISHED") || (prompt.prompt_status === "SUBMITTED" && this.selectedLibrary != "Approval Pending"))) {
      this.drawerService.openDrawer();
      this.promptUserService.isRHSOpen(true);
      this.promptUserService.prompt_id = prompt.id
      this.promptUserService.user_id = this.userid
      this.style2 = true;
      this.promptUserService.getPromptUser(prompt.id, this.userid).subscribe((resp) => {
        this.promptUserDetails = resp.data;
        this.noteslist = this.convertToList(this.promptUserDetails.notes);
        if (this.promptUserDetails.notes === '') {
          this.showNotes = false;
        }
        if (this.promptUserDetails && this.promptUserDetails?.category) {
          this.categories = Object.values(this.promptUserDetails?.category);
          this.createdBy = Object.values(this.promptUserDetails?.created_by);
          this.promptCreatedBy = this.promptUserDetails?.created_by.user_name;
          this.promptCategory = this.promptUserDetails?.category.category_name;
          this.isfavourite = this.promptUserDetails?.is_favourite
          this.published_on = this.promptUserDetails?.published_on;
          this.sub_category = this.promptUserDetails?.sub_category?.sub_category_name
          let detail: any = Object.values(this.promptUserDetails?.prompt_details)[0];
          this.gptScore = !this.promptUserDetails?.prompt_details[0]?.llm?.model_status ? `${this.promptUserDetails?.prompt_details[0]?.llm?.model_name} (Deactivated)` :this.promptUserDetails?.prompt_details[0]?.llm?.model_name;
          this.permanentAttachments = detail?.permanent_attachments;
          this.promptId = this.promptUserDetails?.prompt_id;
          this.attachments = detail?.attachments || [];



          // this.isfavourite = this.promptUserDetails?.is_favourite
          // this.is_favourite

          this.tabs = [];
          this.promptUserDetails?.prompt_details.map((data: any, index: number) => {
            this.myForm = this.fb.group({
              promptDetails: data?.prompt,
              variables: this.fb.array((data?.variables || []).map((variable: string) => this.fb.control(variable))),
              variablesCopy: this.fb.array([]),
              gptQuestion: ""
            });
            this.tabs.push({ label: `Prompt ${index}`, myForm: this.myForm });
            this.parsePromptText(index)

            this.attachmentForm = this.fb.group({
              otherAttachment: [null],
            });
            this.attachmentTabs.push({ attachmentForm: this.attachmentForm });
          })
        }
        // this.cd.detectChanges();
        this.checkIsExpandableContentOverflowed();
        this.cd.markForCheck();

      })
    }
    else if (this.user_role === 'creator' && !this.addfavclicked) {
      this.promptUserService.prompt_id = prompt.id
      this.promptUserService.user_id = this.userid
      if (prompt?.prompt_status == 'DRAFT') {
        this.router.navigateByUrl('/home/prompt-create?role=creator')
      } else {
        // localStorage.setItem("promptId", prompt.id);
        localStorage.setItem("prompt_status", prompt?.prompt_status);
        // this.router.navigateByUrl('/home/user-prompt?selectedlibrary='+this.selectedLibrary);
        this.router.navigateByUrl('/home/prompt-create?role=creator')
      }
    } 
    else if ((this.user_role === 'curator' || this.user_role === 'admin') && !this.addfavclicked) {
      this.promptUserService.prompt_id = prompt.id
      this.promptUserService.user_id = this.userid
      if (prompt?.prompt_status == 'DRAFT' || prompt?.prompt_status == 'REVOKED' || prompt?.prompt_status == 'REJECTED') {
        if (this.user_role === 'curator') {
          this.router.navigateByUrl('/home/prompt-create?role=curator')
        } else if (this.user_role === 'admin') {
          this.router.navigateByUrl('/home/prompt-create?role=admin')
        }
      } else {
        localStorage.setItem("promptId", prompt.id);
        this.promptUserService.isRHSOpen(false);
        this.router.navigateByUrl('/home/user-prompt?selectedlibrary=' + this.selectedLibrary);
      }

      // else {
      //   localStorage.setItem("prompt_status", prompt?.prompt_status);
      //   if (this.user_role === 'curator') {
      //     this.router.navigateByUrl('/home/prompt-create?role=curator')
      //   } else if (this.user_role === 'admin') {
      //     this.router.navigateByUrl('/home/prompt-create?role=admin')
      //   }
      // }
    }
    else if (!this.addfavclicked) {
      this.promptUserService.prompt_id = prompt.id;
      this.promptUserService.user_id = this.userid;
      localStorage.setItem("promptId", prompt.id);
      if (prompt?.prompt_status == 'DRAFT') {
        if (this.user_role === 'curator') {
          this.router.navigateByUrl('/home/prompt-create?role=curator')
        } else if (this.user_role === 'admin') {
          this.router.navigateByUrl('/home/prompt-create?role=admin')
        } else {
          this.router.navigateByUrl('/home/prompt-create?role=creator')
        }
      } else {
        this.promptUserService.isRHSOpen(false);
        this.router.navigateByUrl('/home/user-prompt?selectedlibrary=' + this.selectedLibrary);
      }
    }
    this.toggleBorder(index);
    this.addfavclicked = false
  }

  editVersion(type:any,variant?:any){
    if(variant == 10){
      this.openSnackbar("You can create up to 10 variants, so Variant 11 can't be created.", 'Variant limit reached', 'error-snackbar')
      return;
    }
    this.router.navigateByUrl(`/home/prompt-create?role=creator&for=${type}` )
  }

  parsePromptText(tabPositionIndex: number) {
    const promptDesc = this.tabs[tabPositionIndex].myForm.value.promptDetails
    const matches: [string] = promptDesc.match(/\[\[(.*?)\]\]/g);

    if (matches) {
      const variablesArray = this.tabs[tabPositionIndex].myForm.get('variables') as FormArray;
      const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;

      const newVariables = matches.map((match) => {
        const content = match.slice(2, -2); // Remove [ ]
        return content.includes('/') ? content.split('/') : content;
      });

      // Map existing values from promptVariablesCopy to newVariables
      const updatedVariables = newVariables.map((variable, index) => {
        // const existingVariable = this.promptVariables()[index];
        // const isDropdown = Array.isArray(variable);
        // const existingCopy = this.promptVariablesCopy()[index];
        const existingVariable = variablesArray.at(index)?.value;
        const isDropdown = Array.isArray(variable);
        const existingCopy = variablesCopyArray.at(index)?.value;

        // If the variable exists and matches the type, retain its value
        if (isDropdown && Array.isArray(existingVariable)) {
          return existingCopy || variable;
        } else if (!isDropdown && typeof existingVariable === 'string') {
          return existingCopy || variable;
        } else {
          // For new variables or type mismatches, initialize to default
          return variable;
        }
      });

      // this.promptVariables.set(newVariables); // Update with new variables
      // this.promptVariablesCopy.set(updatedVariables); // Retain updated values



      // Clear the current FormArray
      variablesArray.clear();

      // Populate the FormArray with the new values
      newVariables.forEach((item) => {
        if (Array.isArray(item)) {
          // If the item is an array, push a new FormArray
          variablesArray.push(this.fb.array(item.map((nested) => this.fb.control(nested))));
        } else {
          // If the item is a string, push a FormControl
          variablesArray.push(this.fb.control(item));
        }
      });



      // Clear the current FormArray
      variablesCopyArray.clear();

      // Populate the FormArray with the new values
      updatedVariables.forEach((item) => {
        if (Array.isArray(item)) {
          // If the item is an array, push a new FormArray
          variablesCopyArray.push(this.fb.array(item.map((nested) => this.fb.control(nested))));
        } else {
          // If the item is a string, push a FormControl
          variablesCopyArray.push(this.fb.control(item));
        }
      });

    } else {
      // No matches; clear the variables
      // this.promptVariables.set([]);
      // this.promptVariablesCopy.set([]);

      const variablesArray = this.tabs[tabPositionIndex].myForm.get('variables') as FormArray;
      variablesArray.clear();

      const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;
      variablesCopyArray.clear();
    }

    this.updateInputPromptText(tabPositionIndex);
  }

  onVariableChange(index: number, newValue: any, isDropdown: boolean, tabPositionIndex: number) {
    const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;

    //temp if
    if (variablesCopyArray.at(index)) {
      if (variablesCopyArray && variablesCopyArray.at(index)) {
        // Replace the control at the specified index with a new FormControl containing the string value
        const newControl = this.fb.control(isDropdown ? newValue.value : newValue);

        // Use the replace method to avoid type conflicts
        variablesCopyArray.setControl(index, newControl);
      } else {
        console.warn(`Index ${index} is out of bounds for variablesCopyArray`);
      }
    }

    this.updateInputPromptText(tabPositionIndex); // Sync inputText with updated variables

  }

  updateInputPromptText(tabPositionIndex: number) {
    const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;
    let updatedText = this.tabs[tabPositionIndex].myForm.value.promptDetails;
    let matcheVal: [string] = updatedText.match(/\[\[(.*?)\]\]/g);
    let matches;

    if (matcheVal) {
      matches = matcheVal.map((match) => {
        return match.slice(1, -1); // Remove [ ]
      });
    }

    if (matches) {
      matches.forEach((match, index) => {
        //const newVal = Array.isArray(this.promptVariables[index]) ? `[${(this.promptVariables[index] as string[]).join('/')}]`
        //: this.promptVariables[index];

        //temp if
        if (variablesCopyArray.at(index)) {
          const newVal = Array.isArray(variablesCopyArray.at(index).value) ? `[${(variablesCopyArray.at(index).value as string[]).join('/')}]`
            : variablesCopyArray.at(index).value;
          // updatedText = updatedText.replace(match, `${newVal}`);
          if (Array.isArray(variablesCopyArray.at(index).value)) {
            updatedText = updatedText.replace(`[${match}]`, `[${newVal}]`);
          } else {
            updatedText = updatedText.replace(`[${match}]`, `${newVal}`);
          }
        } else {
          updatedText = updatedText.replace(match, ``);
        }

      })
    }

    this.tabs[tabPositionIndex].myForm.patchValue({
      gptQuestion: updatedText.replace(/\n/g, "")
    })
  }

  // Check if the variable is a string or array
  isString(variable: any): boolean {
    return typeof variable === 'string'
  }

  isArray(variable: any): boolean {
    return Array.isArray(variable)
  }

  removeFavouite(actionType: any, title: string, promId: number = 0) {
    const dialogRef = this.dialog.open(RemoveFavoriteComponent, {
      data: {
        actionType: actionType,
        title: title,
        promId: promId ? promId : this.promptUserService.prompt_id
      },
      height: '250px',
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.remove_fav) {
        this.addToFavouite(result.action_type, result.event, result.prompt_id);
        this.isfavourite = false;
        if(this.selectedLibrary == "My Favourites") {
          this.drawerService.closeDrawer();
        }
      }
    });    
  }

  addToFavouite(actionType: any, event: any = null, promId: number = 0) {
    this.addfavclicked = true
    let prompt_id = (event != null) ? promId : this.promptUserService.prompt_id;
    // const promt_id = 
    // const user_id = this.user_id
    let request = {
      "prompt_id": prompt_id,
      "user_id": this.userid,
      "action_type": actionType
    }
    let favpromtname = ''
    this.promptUserService.addToFavouite(request).subscribe(res => {
      this.getAllPromt();
      this.allPrompt.map((fav: any) => {
        if (fav.id === (promId || prompt_id)
        ) {
          favpromtname = fav.title
          // prompt_status = fav.prompt_status
          localStorage.setItem("favPromptStatus", fav.prompt_status)
        }
      })
      const dialogRef = this.dialog.open(FavComponentDailogComponent, {
        data: {
          favpromtname: favpromtname,
          message: res.message,
          action_type: actionType,
        },

      });

    });
    if (event != null) {
      event.stopPropagation();
    }
    else {
      let promptStatus = localStorage.getItem("favPromptStatus")
      let obj = {
        id: prompt_id,
        prompt_status: promptStatus
      }
      setTimeout(() => {
        this.consumePrompt(obj)
      }, 400);

    }

  }

  showVariantInstruction:boolean=false;
  variant_created_from:string='';
  variant_reason:string='';

  showTooltip(event: MouseEvent,tooltip: string,prompt?:any) {
    if(tooltip == 'version'){
      this.showVersionInstruction = true;
  //     const rect = (event.target as HTMLElement).getBoundingClientRect();

  // this.tooltipStyle = {
  //   top: rect.bottom + 'px',
  //   left: rect.right + 'px',
  //   position: 'absolute'
  // };
  const target = event.target as HTMLElement;
  const rect = target.getBoundingClientRect();

  const tooltipWidth = 150; // Adjust based on actual tooltip width or estimate
  const tooltipHeight = 70;
  const padding = 10;

  let left = rect.right;
  let transform = 'translateX(0%)';

  //  If tooltip would overflow the screen to the right, shift to left side
  if (rect.right + tooltipWidth + padding > window.innerWidth) {
    left = rect.left-tooltipWidth+40 ;
   
    transform = 'translateX(0%)'; // Or leave as is
  }

   //  Adjust top if min-height is >= 200px
  //  const style = getComputedStyle(target);
  //  const minHeightStr = style.minHeight;
  //  const minHeight = minHeightStr === 'auto' ? 0 : parseInt(minHeightStr, 10);
   //const minHeight = parseInt(style.minHeight || '0', 10);
   let topOffset=0;
  if(rect.top + tooltipHeight+20 >window.innerHeight){
    topOffset = tooltipHeight;
  }
   
   
   this.tooltipStyle = {
     top: rect.bottom - topOffset + 'px',
     left: left + 'px',
     transform,
     position: 'absolute',
   };

  // this.tooltipStyle = {
  //   top: rect.bottom + 5 + 'px',
  //   left: left + 'px',
  //   transform,
  //   position: 'absolute',
  // };
      this.version_reason=prompt?.version_reason;
      this.created_from=prompt?.source_version == 0?'Initial Prompt':`version ${prompt?.source_version}`;
     
    }

    if(tooltip == 'variant'){
      this.showVariantInstruction = true;

  const target = event.target as HTMLElement;
  const rect = target.getBoundingClientRect();

  const tooltipWidth = 150; // Adjust based on actual tooltip width or estimate
  const tooltipHeight = 70;
  const padding = 10;

  let left = rect.right;
  let transform = 'translateX(0%)';

  //  If tooltip would overflow the screen to the right, shift to left side
  if (rect.right + tooltipWidth + padding > window.innerWidth) {
    left = rect.left-tooltipWidth+40 ;
    
    transform = 'translateX(0%)'; // Or leave as is
  }

 
   let topOffset=0;
  if(rect.top + tooltipHeight+20 >window.innerHeight){
    topOffset = tooltipHeight;
  }
   

   this.tooltipStyle = {
     top: rect.bottom - topOffset + 'px',
     left: left + 'px',
     transform,
     position: 'absolute',
   };

 
   
      this.variant_reason=prompt?.variant_reason;
      this.variant_created_from=prompt?.variant_source == 0?'Initial Prompt':`${prompt?.variant_source}`;
    
    }
  }
  hideTooltio(tooltip: string) {
    if(tooltip == 'version'){
      this.showVersionInstruction = false;
   
    }
    else if (tooltip == 'variant'){
      this.showVariantInstruction = false;
     
    }
  }


  onFavChnage(event: any) {
    
    const parentid = event.parent_category_id
    setTimeout(() => {
      const itemWithId5 = this.allcategory?.find((item: any) => item.id === parentid);
      this.parentCatename = itemWithId5?.name
      this.cd.markForCheck();
    }, 100)

    this.sort_by = this.selectedValue?.toLowerCase();
    
    if (event.subcategories && event.subcategories.length >= 0) {
      this.parentCate = true
    }
    else {
      this.parentCate = false
    }
    if (typeof event === 'object') {
      this.selectedLibrary = event.name;
      this.promptCount = event.prompt_count;
      this.category_id = [];
      if(event?.title != "" && event?.title != undefined) {
        this.searchtext = event?.title;
      }
    } else {
      this.selectedLibrary = event;
    }
    if (this.selectedLibrary === 'My Favourites') {
      this.sortOptions = this.defaultSortOptions;
      // if(!this.myFavSelectOption) {
        this.selectedValue = "Most Used";
        this.sort_by = this.selectedValue.toLowerCase();
      // } else {
      //   this.selectedValue = this.myFavSelectOptionValue;
      //   this.sort_by = this.selectedValue.toLowerCase();
      // }
      this.onMyFavouriteClick = true;
      this.onMyPromptsClick = false;
      this.onMyApprovalClick = false;
      this.clearfilter = true
      setTimeout(() => {
        this.clearfilter = false
      }, 200)
      this.category_id = []
      this.sub_category_id = []
      this.model = []
      this.status = []
      this.createdbyarray = []
      this.getallprompmtByfilter(
        this.searchtext,
        this.userid,
        [],
        this.category_id,
        this.sub_category_id,
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.onMyApprovalClick,
        this.user_role,
        this.status,
        this.sort_by
      );
      this.getAllCategory(
        this.searchtext,
        this.userid,
        [],
        [],
        [],
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.user_role,
        this.status
      );
      localStorage.setItem("selected_cat", 'My Favourites')
    } else if (this.selectedLibrary === 'My Prompts') {
      this.sortOptions = this.myPromptsApprPendingSortOptions;
      // if(!this.myPromptsSelectOption) {
        this.selectedValue = "New to Old"
        this.sort_by = this.selectedValue.toLowerCase();
      // } else {
      //   this.selectedValue = this.myPromptsSelectOptionValue;
      //   this.sort_by = this.selectedValue.toLowerCase();
      // }
      this.onMyPromptsClick = true;
      this.onMyFavouriteClick = false;
      this.onMyApprovalClick = false;
      this.clearfilter = true
      setTimeout(() => {
        this.clearfilter = false
      }, 200)
      this.category_id = []
      this.sub_category_id = []
      this.model = []
      this.status = []
      this.createdbyarray = []

      this.getallprompmtByfilter(
        this.searchtext,
        this.userid,
        [],
        this.category_id,
        this.sub_category_id,
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.onMyApprovalClick,
        this.user_role,
        this.status,
        this.sort_by
      );
      this.getAllCategory(
        this.searchtext,
        this.userid,
        [],
        [],
        [],
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.user_role,
        this.status,
      );
      localStorage.setItem("selected_cat", 'My Prompts')
    } else if (this.selectedLibrary === 'Approval Pending') {
      this.sortOptions = this.myPromptsApprPendingSortOptions;
      // if  (!this.apprPendingSelectOption) {
        this.selectedValue = "Old to New";
        this.sort_by = this.selectedValue.toLowerCase();
      // } else {
      //   this.selectedValue = this.apprPendingSelectOptionValue;
      //   this.sort_by = this.selectedValue.toLowerCase();
      // }
      this.onMyPromptsClick = false;
      this.onMyApprovalClick = true;
      this.onMyFavouriteClick = false;
      this.clearfilter = true
      setTimeout(() => {
        this.clearfilter = false
      }, 200)
      this.category_id = []
      this.sub_category_id = []
      this.model = []
      this.status = []
      this.createdbyarray = []
      this.getallprompmtByfilter(
        this.searchtext,
        this.userid,
        [],
        this.category_id,
        this.sub_category_id,
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.onMyApprovalClick,
        this.user_role,
        this.status,
        this.sort_by
      );
      this.getAllCategory(
        this.searchtext,
        this.userid,
        [],
        [],
        [],
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.user_role,
        this.status
      );
      localStorage.setItem("selected_cat", 'Approval Pending')
    } else if (this.selectedLibrary === 'All Categories') {
      this.sortOptions = this.defaultSortOptions;
      // if(!this.allCatSelectOption) {
        this.selectedValue = "Most Used";
        this.sort_by = this.selectedValue.toLowerCase();
      // } else {
      //   this.selectedValue = this.allCatSelectOptionValue;
      //   this.sort_by = this.selectedValue.toLowerCase();
      // }
      this.onMyPromptsClick = false;
      this.onMyFavouriteClick = false;
      this.onMyApprovalClick = false;
      this.clearfilter = true
      setTimeout(() => {
        this.clearfilter = false
      }, 200)
      this.category_id = []
      this.sub_category_id = []
      this.model = []
      this.status = []
      this.createdbyarray = []
      this.getallprompmtByfilter(
        this.searchtext,
        this.userid,
        [],
        this.category_id,
        this.sub_category_id,
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.onMyApprovalClick,
        this.user_role,
        this.status,
        this.sort_by
      );
      this.getAllCategory(
        this.searchtext,
        this.userid,
        [],
        [],
        [],
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.user_role,
        this.status
      );
      localStorage.setItem("selected_cat", 'All Categories')
    } else {
      this.sortOptions = this.defaultSortOptions;
      this.selectedValue = "Most Used";
      this.sort_by = this.selectedValue.toLowerCase();
      this.clearfilter = true
      setTimeout(() => {
        this.clearfilter = false
      }, 200)
      this.onMyPromptsClick = false;
      this.onMyFavouriteClick = false;
      this.onMyApprovalClick = false;
      this.category_id = []
      this.sub_category_id = []
      this.createdbyarray = []
      if(Object.keys(event).length > 0) {
        if (event.subcategories) {
          this.category_id.push(event.id);
        }
        else {
          this.sub_category_id.push(event.id)
        }
      }

      this.getallprompmtByfilter(
        this.searchtext,
        this.userid,
        [],
        this.category_id,
        this.sub_category_id,
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.onMyApprovalClick,
        this.user_role,
        this.status,
        this.sort_by
      );
      this.getAllCategory(
        this.searchtext,
        this.userid,
        [],
        [],
        [],
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.user_role,
        this.status
      );
      localStorage.setItem("selected_cat", JSON.stringify(event))
    }
    this.getModel();
  }

  onDrawerClosed() {
    this.drawerService.closeDrawer();
  }
  toggleBorder(index?: number) {
    if (index !== 0 && !index) return;
    this.selectedCardIndex = this.selectedCardIndex === index ? null : index; // Toggle selection
    if (this.selectedCardIndex == null) {
      this.drawerService.closeDrawer();
    }
  }


  // onFileChange(event: any, uploadType: string, index: number) {
  //   const {files} = event.target;

  //   for (let i = 0; i < files.length; i++) {
  //     this.attachments.push(files[i]);
  //     this.attachments.push(files[i].name);
  //   }
  //   this.promptUserService.changeData(this.attachments);
  //   this.otherAttachmentsContainer?.nativeElement.scrollIntoView({
  //     behavior: 'smooth',
  //     block: 'end'
  //   });
  // }

  // deleteFile(f: any) {
  //   this.attachments = this.attachments.filter(function (w) {
  //     return w.name != f.name;
  //   });
  //   this._snackBar.open('Successfully delete!', 'Close', {
  //     duration: 2000,
  //   });
  // }

  // addToFeedback() {
  //   const dialogRef = this.dialog.open(RatingFeedbackComponent, {
  //     data: {
  //       message: '',
  //     },
  //     height: '450px',
  //     width: '500px'
  //   });
  // }

  addToFeedback(event: any,prompt_id?:any,prompt_title?:any) {

    const dialogRef = this.dialog.open(RatingFeedbackComponent, {
      data: {
        message:prompt_title??'',
        prompt_id_val:prompt_id ??'',
        rating: this.promptUserDetails?.my_rating,
        prompt_details:this.promptUserDetails,
        remind_me_later_count:this.promptUserDetails?.remind_me_later_count ,
      },
      width: '500px',
      height: '610px',
      disableClose: true // Prevent closing without interaction
    });
    
    dialogRef.afterClosed().subscribe(data => {
      

  
      this.promptUserDetails.my_rating = data?.rating > 0 ? data?.rating : this.promptUserDetails.my_rating;
      this.promptUserDetails.remind_me_later_count=data?.remind_me_later_count>0 ? data?.remind_me_later_count :this.promptUserDetails.remind_me_later_count;
      this.promptUserDetails.comments=data?.comments ? data?.comments :this.promptUserDetails.comments;
      
      //this.promptUserDetails.time_saved=data?.time_saved>0 ? data?.time_saved :this.promptUserDetails?.time_saved;
      
    })
  }

  breadcrumbclick(selected: any,text?:string) {
    
    // if(selected == 'back'){
    //   this.parentCate=true;
    // }else{
    if(selected == 'All Category'){
    this.selectedLibrary = selected
    this.parentCate=false;
    this.parentCatename=null;
    }else if(text == 'parentCatename'){
      this.selectedLibrary=selected;
      this.parentCate=true;

    }
    else{
      this.selectedLibrary=selected;

    }
    let event:any ={};
    if(selected =='All Category'){
      event= "All Categories";
      this.selectedLibrary="All Categories";
      this.parentCatename="All Categories";
      this.onFavChnage(event);
      this.FavComponent.onFavSelect('All Categories')
    }
    else if(text == 'parentCatename'){
    event=this.allcategory.find((data:any)=>data.name == selected);
    this.onFavChnage(event);
    this.FavComponent.onFavSelect(event);

    }
  }

  // runPrompt(event: any) {
  //   this.isPromptRunning = true;
  //   localStorage.setItem('isPromptRunning', 'true');
  //   setTimeout(() => {
  //     this.router.navigateByUrl('/home/user-prompt?selected_prompt='+this.promptId);
  //     this.selectedCardIndex = null
  //     this.drawerService.closeDrawer();
  //   }, 1000);
  // }

  changePromptDetails(event: any) {
    this.selectedIndex = event.selectedIndex;
    if (event.selectedIndex == 0 || event.selectedIndex == 1) {
      this.promptUserService.setStepperIndex(event.selectedIndex);
    } else {
      this.promptUserService.setStepperIndex(0);
    }
    if(this.promptUserDetails?.prompt_details[this.selectedIndex]?.llm?.model_name){
    this.gptScore=!this.promptUserDetails?.prompt_details[this.selectedIndex]?.llm?.model_status ? `${this.promptUserDetails?.prompt_details[this.selectedIndex]?.llm?.model_name} (Deactivated)`: this.promptUserDetails?.prompt_details[this.selectedIndex]?.llm?.model_name;
    }
  }

  // getStepIcon(index: number): string {
  //   if (index < this.selectedIndex) {
  //     return 'edit';
  //   } else if (index === this.selectedIndex) {
  //     return 'done';
  //   } else {
  //     return 'number';
  //   }
  // }

  openPrompt(event: any) {
    this.promptUserService.shareAttachment(this.attachmentTabs)
    localStorage.setItem("uploadDocsResponseSet", "true");
    localStorage.setItem("promptSelectedIndex", this.selectedIndex?.toString());
    this.promptCreateService.setStorredAttachmets(this.attachments?.filter((file: any) => {
      if (typeof (file) != "string") {
        return file;
      }
    }));
    this.selectedCardIndex = null;
    this.selectedIndex = null;
    this.drawerService.closeDrawer();
    this.router.navigateByUrl('/home/user-prompt?selected_prompt=' + this.promptId);
  }

  clearAllFilter() {
    this.clearfilter = false
    setTimeout(() => {
      this.clearfilter = true
      this.cd.markForCheck();
      this.category_id = []
      this.sub_category_id = []
      this.model = []
      this.status = []
      this.createdbyarray = []
      this.getallprompmtByfilter(
        this.searchtext,
        this.userid,
        this.modal,
        this.category_id,
        this.sub_category_id,
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.onMyApprovalClick,
        this.user_role,
        this.status,
        this.sort_by
      );
      this.getAllCategory(
        this.searchtext,
        this.userid,
        this.modal,
        [],
        [],
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.user_role,
        this.status
      );

      setTimeout(() => {
        this.clearfilter = false
        this.cd.markForCheck();
      }, 10)

    }, 10)
    this.getModel();
    this.selectedLibrary = 'All Categories';
    this.FavComponent.onFavSelect('All Categories');
    localStorage.setItem("selected_cat", 'All Categories');
  }

  onClickExpand(event: any) {
    this.isExpand = !this.isExpand
    if (!this.isExpand) {
      this.expandableContent?.nativeElement.parentElement.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      // this.expandableContent?.nativeElement.scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start'
      // });
    }
  }

  resetClick() {
    this.formdata.reset()
  }

  promptVariableResetHandler(event: Event) {
    const variablesArray = this.tabs[this.selectedIndex].myForm.get('variables') as FormArray;
    variablesArray.clear();

    const variablesCopyArray = this.tabs[this.selectedIndex].myForm.get('variablesCopy') as FormArray;
    variablesCopyArray.clear();
    this.parsePromptText(this.selectedIndex);
  }

  formdata = this.fb.group({
    topic: ['', []], Adjective: ['', []], Adjective1: ['', []], topic1: ['', []], Adjective2: ['', []]
  });

  isDragOver = false;
  onDragOver(event: any, uploadType: string, index: number) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: any, uploadType: string, index: number) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: any, uploadType: string, index: number) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;


    if (event.dataTransfer?.files) {
      const droppedFiles = Array.from(event.dataTransfer.files);
     
      this.onFileChange(event, uploadType, index)
    }
  }

  onFileChange(event: any, uploadType: string, index: number) {
    // const {files} = event.target;

    // for (let i = 0; i < files.length; i++) {
    //   this.attachments.push(files[i].name);
    // }

    type AttachmentType = {
      file_type: string;
      index: number;
      selected: File;
      page_number: string;
    }[];
    let get_file_extension_re = /(?:\.([^.]+))?$/;
    const selectedFiles = event.target.files || event.dataTransfer.files;

    if (selectedFiles) {
      //const selectedFiles = event.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        //if(selectedFiles[i]?.type === 'application/pdf'){
          if (uploadType === 'otherAttachment') {
            let otherAttachmentDup: AttachmentType = this.attachmentTabs[index].attachmentForm.value.otherAttachment || [];
            if (otherAttachmentDup.length > 0) {
              if (
                otherAttachmentDup.some(
                  (existingFile) => existingFile.selected.name === selectedFiles[i]?.name
                )
              ) {
                this.openSnackbar("Duplicate prompt attachment: " + selectedFiles[i]?.name, 'An error occurred', 'error-snackbar')
                break;
              } else {
                let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";
                otherAttachmentDup.push({ "selected": selectedFiles[i], "index": otherAttachmentDup.length + 1, "file_type": file_extension, "page_number": "" })
                this.attachmentTabs[index].attachmentForm.patchValue({
                  otherAttachment: otherAttachmentDup
                });
                //this.perminentAttachments.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension });
              }
            } else {
              let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";

              const newAttachment = {
                selected: selectedFiles[i],
                index: otherAttachmentDup.length + 1,
                file_type: file_extension,
                page_number: ""
              };
              const updatedAttachments = [newAttachment];
              this.attachmentTabs[index].attachmentForm.patchValue({
                otherAttachment: updatedAttachments
              });
              //this.perminentAttachments.push(newAttachment)
            }

          }
        //} else {
        //  this.openSnackbar('Only PDF files are allowed', 'An error occurred', 'error-snackbar')
        //}
      }
    }


    // this.promptUserService.changeData(this.attachments);
    // this.otherAttachmentsContainer?.nativeElement.scrollIntoView({
    //   behavior: 'smooth',
    //   block: 'end'
    // });

  }

  deleteFile(attachment_index: number, fileType: string, tabIndex: number, filename: string) {
    type AttachmentType = {
      file_type: string;
      index: number;
      selected: File;
      page_number: string;
    }
    if (fileType == "otherAttachment") {
      let tempperment: any[] = [];
      tempperment = this.attachmentTabs[tabIndex].attachmentForm.value.otherAttachment.filter((file: AttachmentType) => {
        return file.selected.name != filename
      })

      this.attachmentTabs[tabIndex].attachmentForm.patchValue({
        otherAttachment: tempperment
      });
    }
  }

  completedSteps = new Set<number>(); // Tracks steps where "Run" has been clicked
  // Check if a step is completed
  isStepCompleted(index: number): boolean {

    return this.completedSteps.has(index);
  }

  openSnackbar(message: string, title: string, cssClass: string) {
    // this.snackBar.openFromComponent(SnackBarComponent, {
    //   data: { message: message, type: type },
    //   duration: 3000, // Duration in milliseconds,
    //   horizontalPosition: 'center',
    //   verticalPosition: 'top',
    //   panelClass: [cssClass],
    // });
     const dialogRef = this.dialog.open(ErrorNotficationComponent, {
        data: {
          message: message,
          title: title,
          action_type: 'add',
          cssClass: cssClass
        }
      });
  }

  trackByIndex(index: number, item: any): any {
    return index; // or item.id if available
  }
  
}
